import {
    UPDATE_AUTHENTICATING,
    SHOULD_AUTHENTICATE,
	UPDATE_VIEW_STATE,
	RECEIVE_PINS,
    RECEIVE_CHARGERS_IN_VIEWPORT,
	FETCHING_PINS,
	SET_SELECTED_PIN,
    SET_ACTIVE_PIN,
	UPDATE_PINS_GEOJSON,
	RECEIVE_PINS_FETCH_ERROR,
    UPDATE_LOAD_MAP,
    TOGGLE_EXPANDED_FILTER_BUTTON,
    UPDATE_NON_TESLA_ONLY,
	RECEIVE_DATA,
	FETCHING_DATA,
	RECEIVE_DATA_ERROR,
	RECEIVE_POPULAR_TIMES,
	RECEIVE_AWARDS,
	RECEIVE_POSTS,
	FETCHING_POSTS,
	RECEIVE_POSTS_ERROR,
	RECEIVE_ZAPS,
	FETCHING_ZAPS,
	RECEIVE_ZAPS_ERROR,
    RECEIVE_ACTIVE_ZAP,
    FETCHING_RECENT_CHARGES,
    RECEIVE_RECENT_CHARGES,
    RECEIVE_RECENT_ERROR,
    CHECKING_LOCATION,
    RESET_ACTIVE_CHARGER_STATE,
    RECEIVE_SAVED_VIEW,
    UPDATE_RUNNING_INITIAL_FETCH,
    RECEIVE_COUNTRY_CODE,
    RECEIVE_CURRENCY_CODE
} from './reducers'

// auth

export const updateAuthenticating = payload => ({ 
    type: UPDATE_AUTHENTICATING,
    payload
})

export const updateShouldAuthenticate = payload => ({ 
    type: SHOULD_AUTHENTICATE,
    payload
})

// map
export const checkingLocationAction = payload => ({
    type: CHECKING_LOCATION,
    payload
})

export const updateViewState = payload => ({
	type: UPDATE_VIEW_STATE,
	payload,
})

export const receivePins = payload => ({
	type: RECEIVE_PINS,
	payload,
})

export const receiveChargersInViewport = payload => ({
    type: RECEIVE_CHARGERS_IN_VIEWPORT,
    payload
})

export const fetchingPins = payload => ({
	type: FETCHING_PINS,
	payload,
})

export const setSelectedPin = payload => ({
	type: SET_SELECTED_PIN,
	payload,
})

export const setActivePin = payload => ({
    type: SET_ACTIVE_PIN,
    payload
})

export const updatePinsGeojson = payload => ({
	type: UPDATE_PINS_GEOJSON,
	payload,
})

export const receivePinsFetchError = payload => ({
	type: RECEIVE_PINS_FETCH_ERROR,
	payload,
})

export const receiveSavedView = payload => ({
    type: RECEIVE_SAVED_VIEW,
    payload
})

export const updateLoadMap = payload => ({
    type: UPDATE_LOAD_MAP,
    payload
})

export const updateRunningInitialFetch = payload => ({
    type: UPDATE_RUNNING_INITIAL_FETCH,
    payload
})

export const toggleExpandedFilterButton = payload => ({
    type: TOGGLE_EXPANDED_FILTER_BUTTON,
    payload
})

export const updateNonTeslaOnly = payload => ({
    type: UPDATE_NON_TESLA_ONLY,
    payload
})


// charger

export const receiveData = payload => ({
    type: RECEIVE_DATA,
    payload
})

export const fetchingData = payload => ({
    type: FETCHING_DATA,
    payload
})

export const receiveDataError = payload => ({
    type: RECEIVE_DATA_ERROR,
    payload
})

export const receivePopularTimes = payload => ({
    type: RECEIVE_POPULAR_TIMES,
    payload
})

export const receiveAwards = payload => ({
    type: RECEIVE_AWARDS,
    payload
})

export const receivePosts = payload => ({
    type: RECEIVE_POSTS,
    payload
})

export const fetchingPosts = payload => ({
    type: FETCHING_POSTS,
    payload
})

export const receivePostsError = payload => ({
    type: RECEIVE_POSTS_ERROR,
    payload
})

// export const receiveProblems = payload => ({
//     type: RECEIVE_PROBLEMS,
//     payload
// })

// export const fetchingProblems = payload => ({
//     type: FETCHING_PROBLEMS,
//     payload
// })

// export const receiveProblemsError = payload => ({
//     type: RECEIVE_PROBLEMS_ERROR,
//     payload
// })

export const receiveZaps = payload => ({
    type: RECEIVE_ZAPS,
    payload
})

export const fetchingZaps = payload => ({
    type: FETCHING_ZAPS,
    payload
})

export const receiveZapsError = payload => ({
    type: RECEIVE_ZAPS_ERROR,
    payload
})

export const receiveActiveZap = payload => ({
    type: RECEIVE_ACTIVE_ZAP,
    payload
})

export const fetchingRecentCharges = payload => ({
    type: FETCHING_RECENT_CHARGES,
    payload
})

export const receiveRecentCharges = payload => ({
    type: RECEIVE_RECENT_CHARGES,
    payload
})

export const receiveRecentError = payload => ({
    type: RECEIVE_RECENT_ERROR,
    payload
})

export const resetActiveChargerState = () => ({
    type: RESET_ACTIVE_CHARGER_STATE
})

// localization

export const receiveCountryCode = payload => ({
    type: RECEIVE_COUNTRY_CODE,
    payload
})

export const receiveCurrencyCode = payload => ({
    type: RECEIVE_CURRENCY_CODE,
    payload
})
